import { createTheme } from '@mui/material/styles';
import palette from "./palette";
import typography from "./typography";
import breakpoints from "./breakpoints";
import overrides from "./overrides";

const theme = createTheme({
  palette,
  typography,
  breakpoints,
  overrides,
});

export default theme;
